/* eslint-disable prettier/prettier */
const textSystem = {
  FUKUOKA: {
    "GOCHIプラットフォーム管理システム": '福岡市子ども習い事\n応援事業 管理システム',
    "福岡市子ども習い事応援事業": '福岡市子ども習い事応援事業',
    "ごちめし": '福岡市子ども習い事応援事業',
    "例) 東京都 渋谷区 0-0-0": '例 福岡県 福岡市 大名...',
    "ごちコード消込": '紙/カード型クーポン消込',
    "領収書NO": '紙/カード型クーポンNo',
    "購入日 (From)": '紙/カード型クーポン発行日（From）',
    "購入日 (To)": '紙/カード型クーポン発行日（To）',
    "領収書No": '紙/カード型クーポンNo',
    "購入日": '紙/カード型クーポン発行日',
    "紙/カード型クーポン消込": '紙/カード型クーポン消込',
    "購入日(From)": '紙/カード型クーポン発行日(From)',
    "購入日(To)": '紙/カード型クーポン発行日(To)',
    "例) 東京都 1-2-3": '例) 福岡県 福岡市 大名...',
    "画像は１枚につき8MB以内でお願いします。\n画像は５枚まで登録できます。複数枚登録した場合は、店舗詳細画面でスライド表示されます。\n店舗一覧には１番目に登録した画像が表示されます。": "画像は１枚につき8MB以内でお願いします。\n画像は５枚まで登録できますが、福岡市子ども習い事応援事業のクーポン利用画面には１番目に登録した画像が表示されます。",
    "画像は５枚まで登録できます。複数枚登録した場合は、店舗詳細画面でスライド表示されます。\n店舗一覧には１番目に登録した画像が表示されます。": "画像は１枚につき8MB以内でお願いします。\n画像は５枚まで登録できますが、福岡市子ども習い事応援事業のクーポン利用画面には１番目に登録した画像が表示されます。",
    "福岡市子ども習い事応援事業専用サイト": '福岡市子ども習い事応援事業専用サイト',
  },
  SUITA: {
    "GOCHIプラットフォーム管理システム": '吹田市子供の習い事\n費用助成事業 管理システム',
    "福岡市子ども習い事応援事業": '吹田市子供の習い事費用助成事業',
    "ごちめし": '吹田市子供の習い事費用助成事業',
    "例) 東京都 渋谷区 0-0-0": '例）大阪府 吹田市…',
    "ごちコード消込": 'カード型クーポン消込',
    "領収書NO": 'カード型クーポンNo',
    "購入日 (From)": 'カード型クーポン発行日（From）',
    "購入日 (To)": 'カード型クーポン発行日（To）',
    "領収書No": 'カード型クーポンNo',
    "購入日": 'カード型クーポン発行日',
    "紙/カード型クーポン消込": 'カード型クーポン消込',
    "購入日(From)": 'カード型クーポン発行日(From)',
    "購入日(To)": 'カード型クーポン発行日(To)',
    "例) 東京都 1-2-3": '例）大阪府 吹田市…',
    "画像は１枚につき8MB以内でお願いします。\n画像は５枚まで登録できます。複数枚登録した場合は、店舗詳細画面でスライド表示されます。\n店舗一覧には１番目に登録した画像が表示されます。": "画像は１枚につき8MB以内でお願いします。\n画像は５枚まで登録できます。複数枚登録した場合は、教室詳細画面でスライド表示されます。\n教室一覧には１番目に登録した画像が表示されます。",
    "画像は５枚まで登録できます。複数枚登録した場合は、店舗詳細画面でスライド表示されます。\n店舗一覧には１番目に登録した画像が表示されます。": "画像は１枚につき8MB以内でお願いします。\n画像は５枚まで登録できます。複数枚登録した場合は、教室詳細画面でスライド表示されます。\n教室一覧には１番目に登録した画像が表示されます。",
  },
  NISHIWAKI: {
    "GOCHIプラットフォーム管理システム": '西脇市こども未来応援事業',
    "例) 東京都 渋谷区 0-0-0": '例）兵庫県 西脇市...',
    "例) 東京都 1-2-3": '例）兵庫県 西脇市...',
    "福岡市子ども習い事応援事業": '西脇市こども未来応援事業',
    "ごちめし": '西脇市こども未来応援事業',
    "福岡市子ども習い事応援事業専用サイト": '西脇市こども未来応援事業専用サイト',
  }
};

export const nameSystem = {
  fukuoka: 'FUKUOKA',
  suita: 'SUITA',
  nishiwaki: 'NISHIWAKI'
};

export default textSystem;
